import React, { useEffect } from 'react';
import {
  ApiError,
  Banner as UiBanner,
  Gutter,
  useApiWithErrors,
} from '@axiom/ui';

import { LegacyBannerMessagesApi } from '../../api/legacy-banner-messages-api';

export const Banner = () => {
  const [bannerResponse] = useApiWithErrors(
    LegacyBannerMessagesApi.readBannerMessages({ appName: 'envoy' })
  );

  useEffect(() => {
    const fetchInterval = setInterval(() => {
      void LegacyBannerMessagesApi.refreshBannerMessages({ appName: 'envoy' });
    }, 30000); // 30 Seconds

    return () => {
      clearInterval(fetchInterval);
    };
  }, []);

  const bannerMessage =
    bannerResponse instanceof ApiError ? null : bannerResponse.data;

  if (!bannerMessage?.isActive) {
    return null;
  }

  return (
    <Gutter bottom="8px">
      <UiBanner name="BANNER_MESSAGE" type="warning" impact="high">
        <span dangerouslySetInnerHTML={{ __html: bannerMessage.html ?? '' }} />
      </UiBanner>
    </Gutter>
  );
};
